<template>
  <div class="income_page">
    <h1>基础营收报表</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 220px"
        v-model="curChannel.selectValue"
        multiple
        placeholder="请选择渠道"
        collapse-tags
        @change="channelChange"
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>

      <el-select filterable style="width: 160px" v-model="country" placeholder="">
        <el-option
          v-for="(item, itemIndex) in countryList"
          v-bind:key="itemIndex + 99"
          :label="item.country"
          :value="item.countryCode"
        ></el-option>
      </el-select>
      <el-select filterable style="width: 160px" v-model="language" placeholder="">
        <el-option
          v-for="(item, itemIndex) in languageList"
          v-bind:key="itemIndex + 99"
          :label="item.language"
          :value="item.langCode"
        ></el-option>
      </el-select>

      <DatePicker2 @datePickedChange="datePickedChange"></DatePicker2>
      <el-button type="primary" @click="doInquery">查询</el-button>
      <el-button type="primary" @click="downloadReport">下载</el-button>
    </div>
    <div class="display-type">
      <CustomTable1
        :tableList="tableList"
        :options="tableOptions"
        class="table"
        :pageSize="10"
        :total="pageInfo.total"
        :currentPage="pageInfo.currentPage"
        @handleCurrentChange="handleCurrentChange"
      ></CustomTable1>
    </div>
    <div v-loading="loading">
      <CustomLine :options="lineOptions"></CustomLine>
    </div>
  </div>
</template>

<script>
import CustomTable1 from "../../components/CustomTable1";
import DatePicker2 from "../../components/DatePicker2";
import CustomLine from "../../components/CustomLine";
import { getCountry } from "../../utils/normalApi.js";
import { getLanguage } from "@/utils/normalApi.js";
export default {
  components: {
    CustomTable1,
    DatePicker2,
    CustomLine,
  },
  data() {
    return {
      country: "total",
      countryList: [],
      curChannel: {
        selectValue: ["total"],
        content: "",
      },
      channels: this.$store.state.channels,
      datePicked: [
        this.$store.getters.dateTwoDayBefore,
        this.$store.getters.dateOneDayBefore,
      ],
      tableOptions: {
        defaultSort: {
          prop: "date",
          order: "ascending",
        },
        theader: [
          {
            name: "date",
            label: "日期",
            sortable: true,
            fixed: true,
            width: "180px",
          },
          {
            name: "channel",
            label: "平台",
            sortable: true,
            fix: true,
            width: "180px",
          },
          {
            name: "totalRechargeAmount",
            label: "充值总金额",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "dau",
            label: "DAU",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "newUserCount",
            label: "新增人数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "rechargeUserCount",
            label: "充值总人数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "rechargeCount",
            label: "充值总次数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "newRechargeUserCount",
            label: "新增充值人数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "newPayRate",
            label: "新增付费率",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "newRechargeCount",
            label: "新增充值次数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "newRechargeAmount",
            label: "新增充值金额",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "newArppu",
            label: "新增Arppu",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "payGoldUserCount",
            label: "付费人数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "payGoldCount",
            label: "付费次数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "newPayGoldUserCount",
            label: "新增付费人数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "newPayGoldCount",
            label: "新增付费次数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "payGold",
            label: "付费金额",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "newGainGold",
            label: "新用户赠送金币",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "sendGiftUserCount",
            label: "送礼人数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "sendGiftCount",
            label: "送礼次数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "sendGiftValue",
            label: "送礼总收入",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "videoChatValue",
            label: "视频通话营收",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "audioChatValue",
            label: "语音通话收入",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "videoValue",
            label: "私密视频收入",
            sortable: true,
            fix: true,
            width: "150px",
          },
        ],
      },
      tableList: [],
      lineOptions: {
        title: "基础营收",
        legend: [
          "充值总金额",
          "dau",
          "新增人数",
          "充值总人数",
          "充值总次数",
          "新增充值人数",
          "新增充值次数",
          "新增充值金额",
        ],
        xAxis: {
          name: "日期",
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          name: "数量",
          type: "value",
        },
        series: [
          {
            name: "充值总金额",
            type: "line",
            smooth: true,
            data: [],
          },
          {
            name: "dau",
            type: "line",
            smooth: true,
            data: [],
          },
          {
            name: "新增人数",
            type: "line",
            smooth: true,
            data: [],
          },
          {
            name: "充值总人数",
            type: "line",
            smooth: true,
            data: [],
          },
          {
            name: "充值总次数",
            type: "line",
            smooth: true,
            data: [],
          },
          {
            name: "新增充值人数",
            type: "line",
            smooth: true,
            data: [],
          },
          {
            name: "新增充值次数",
            type: "line",
            smooth: true,
            data: [],
          },
          {
            name: "新增充值金额",
            type: "line",
            smooth: true,
            data: [],
          },
        ],
      },
      pageInfo: {
        total: 0,
        currentPage: 1,
      },
      loading: true,
      languageList: [],
      language: "all",
    };
  },
  beforeCreate() {},
  async created() {
    await this._getLanguage();
    this.getList();
    const res = await getCountry();
    if (res !== null) {
      this.countryList = res.countryList;
    }
  },
  async mounted() {},
  computed: {
    username() {
      return this.$store.getters.username;
    },
    userLevel() {
      return this.$store.getters.userLevel;
    },
    token() {
      return this.$store.getters.token;
    },
  },
  watch: {},
  methods: {
    async _getLanguage() {
      const res = await getLanguage();
      if (res !== null) {
        this.languageList = res;
        this.language = res[0].langCode;
      }
    },
    channelChange(currentVal) {
      const currentValLen = currentVal.length;
      if (currentValLen !== 1) {
        if (
          currentVal[currentValLen - 1] === "total" ||
          currentVal[currentValLen - 1] === "all"
        ) {
          this.curChannel.selectValue = [currentVal[currentValLen - 1]];
        }
      }

      if (currentValLen === 2) {
        if (currentVal[0] === "total" || currentVal[0] === "all") {
          this.curChannel.selectValue = [currentVal[currentValLen - 1]];
        }
      }
    },
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val;
      this.getList();
    },
    datePickedChange(date) {
      this.datePicked = date;
    },
    //获取基础营销数据
    getList() {
      this.loading = true;
      this.$axios({
        type: "GET",
        url: this.$store.getters.path.reports_income_logs,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.datePicked[0],
          end: this.datePicked[1],
          channel: this.curChannel.selectValue.join(","),
          country: this.country,
          language: this.language,
          page: this.pageInfo.currentPage,
        },
      })
        .then(
          (res) => {
            if (res.data.code === 0) {
              this.tableListBuild(res.data.data.data);
              this.lineOptionBuild(res.data.data.data);
              this.pageInfo.total = res.data.data.total;
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
              this.$router.push(this.$route.query.redirect || "/login");
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          },
          (err) => {
            this.$message({
              showClose: true,
              message: "请求错误:" + err,
              type: "error",
            });
          }
        )
        .then(() => {
          this.loading = false;
        });
    },
    //表格数据
    tableListBuild(data) {
      this.tableList = data;
    },
    doInquery() {
      this.getList();
    },
    // 生成并下载主播excel
    downloadReport() {
      window.location.href =
        this.$store.getters.path.reports_download_income +
        "?token=" +
        this.token +
        "&start=" +
        this.datePicked[0] +
        "&end=" +
        this.datePicked[1] +
        "&channel=" +
        this.curChannel.selectValue.join(",") +
        "&country=" +
        this.country +
        "&username=" +
        this.username;
    },
    // 折线图配置
    lineOptionBuild(data) {
      this.lineOptions.xAxis.data = [];
      for (let i = 0; i < this.lineOptions.series.length; i++) {
        this.lineOptions.series[i].data = [];
      }
      for (let j in data) {
        if (data.hasOwnProperty(j)) {
          this.lineOptions.xAxis.data.push(j);
          this.lineOptions.series[0].data.push(data[j].totalRechargeAmount);
          this.lineOptions.series[1].data.push(data[j].dau);
          this.lineOptions.series[2].data.push(data[j].newUserCount);
          this.lineOptions.series[3].data.push(data[j].rechargeUserCount);
          this.lineOptions.series[4].data.push(data[j].rechargeCount);
          this.lineOptions.series[5].data.push(data[j].newRechargeUserCount);
          this.lineOptions.series[6].data.push(data[j].newRechargeCount);
          this.lineOptions.series[7].data.push(data[j].newRechargeAmount);
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.income_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
